export default __webpack_public_path__ + "static/media/video1.fb96a15f.png";